const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.png",
      txt: "유품정리 전문",
    },
    {
      img: "/images/service2.png",
      txt: "쓰레기집 전문",
    },
    {
      img: "/images/service3.png",
      txt: "특수청소 전문",
    },
    {
      img: "/images/service4.png",
      txt: "빈집정리 전문",
    },
    {
      img: "/images/service5.png",
      txt: "고독사청소 전문",
    },
    {
      img: "/images/service6.png",
      txt: "폐기물 처리 전문",
    },
  ];
  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)]  mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div id="title" className="relative w-full h-fit text-center mb-10">
        <div className="relative w-full h-fit">
          <h2 className="leading-none gmedium">몽땅의&nbsp;서비스&nbsp;목록</h2>
          <h4 className="text-secondary gmedium">-&nbsp;SERVICE&nbsp;-</h4>
        </div>
        <p className="text-[#9e9e9e] text-lg lg:text-xl xl:text-2xl mt-3 xl:mt-5">
          몽땅에서는 전문적인 폐기물 관련 및 정리 서비스를 받아보실 수 있습니다.
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-5">
        {serviceList.map((v, i) => (
          <div key={i} data-aos="fade-up" className="relative w-full h-full bg-white p-3 border shadow-lg rounded-md">
            <div className="relative w-full h-full overflow-hidden">
              <img
                className="!relative w-full h-40 xs:h-48 md:h-64 lg:h-96 object-cover hover:scale-110 transition-transform duration-300"
                alt="service"
                src={v.img}
                width={368}
                height={373}
              />
            </div>
            <div className="absolute bottom-0 left-0 w-full h-fit bg-white text-center text-light pt-3 pb-2">
              <p className="lg:text-3xl">{v.txt}</p>
            </div>
          </div>
        ))}
        <div
          onClick={() => (window.location.href = "9806-4573")}
          data-aos="fade-up"
          className="col-span-2 relative  grid items-center px-5"
        >
          <img
            className=" relative w-full h-40 xs:h-48 md:h-64 lg:h-72 py-2 object-contain"
            src="/images/service7.png"
            alt="number"
          />
        </div>
      </div>
    </div>
  );
};

export default Service;
